const template = require('./index.html')
const { v4: uuid } = require('@lukeed/uuid')

const defaultOptions = {
	twoway: false,
	lazy: true,
	isolated: true,
}

module.exports = function({ twoway = false, lazy = true, isolated = true } = defaultOptions) {
	return Ractive.extend({
		template,
		twoway,
		lazy,
		isolated,
		computed: {
			isSaved() {
				const savedInputIdList = this.get('savedInputIdList')
				const inputId = this.get('controlFor')

				if (Array.isArray(savedInputIdList)) {
					return savedInputIdList && (savedInputIdList.findIndex(item => item === inputId) > -1)
				} else if (typeof savedInputIdList === 'string') {
					return savedInputIdList === inputId
				}
			},
			computedParentDivClass() {
				return this.get('parentDivClass') + (this.get('showLabel') ? ' mb-1' : '')
			},
			computedLabelClass() {
				return this.get('labelClass') + (this.get('required') ? ' font-weight-bold' : '')
			},
		},
		data() {
			return {
				label: null,
				hint: '',
				hintClass: '',
				showLabel: true,
				styleClass: '',
				disabled: false,
				isLoading: false,
				hasError: false,
				controlFor: '',
				value: null,
				id: uuid(),
				easeIn: false,
				style: '',
				title: '',
				textEllipsis: false,
				parentDivClass: 'form-group',
				labelOnly: false,
				labelRight: false,
				labelClass: '',
			}
		},
	})
}
